import React, { memo } from 'react';
import classnames from 'classnames/bind';
import { withScreenResizeDetectHoc, } from '@wildberries/ui-kit';
import { Skeleton } from './_components/skeleton';
import styles from './index.module.scss';
var cn = classnames.bind(styles);
var BLOCK_NAME = 'SimpleContentPreview';
export var WraooedComponent = memo(function (_a) {
    var screenType = _a.screenType;
    return (React.createElement("div", { className: cn(BLOCK_NAME) },
        React.createElement(Skeleton, { screenType: screenType })));
});
export var SimpleContentPreview = withScreenResizeDetectHoc({})(WraooedComponent);
